// extracted by mini-css-extract-plugin
export var pillWrapper = "_lu-0";
export var showOverflow = "_lu-1";